module.exports = __webpack_public_path__ + "img/img4.e4c89248.jpg";